import type { ActionReducerMap } from '@ngrx/store';
import type { AppState } from './app.state';
import { brandingReducer } from './branding/branding.reducer';
import { combinedListReducer } from './combined-list/combined-list.reducer';
import { dashboardingReducer } from './dashboarding/dashboarding.reducer';
import { entitiesReducer } from './entities/entities.reducer';
import { pagesReducer } from './pages/pages.reducer';
import { profileReducer } from './profile/profile.reducer';

export const reducers: ActionReducerMap<AppState, any> = {
    branding: brandingReducer,
    combinedList: combinedListReducer,
    dashboarding: dashboardingReducer,
    profile: profileReducer,
    entities: entitiesReducer,
    pages: pagesReducer
};
